import React from 'react';
import YoutubeBigPage from 'pages/Dashboard/Widgets/Youtube/YoutubeBig'
import useRequest from '../../../../hooks/use-request';
import { YOUTUBE_CHANNEL_API_URL } from '../../../../utils/api';

const YoutubeBig = (props) => {
    const [handleRequest, status] = useRequest()
    const [data, setData] = React.useState()

    React.useEffect(() => {
        if (props.demo) {
            return
        }
        handleRequest("get", YOUTUBE_CHANNEL_API_URL(props.channel), {}, {}, (data, status) => {
            if (status === "Done") {
                setData(data);
            } else if (status === "Error") {
                console.error(data);
            }
        }, true)
    }, [])

    const handleReload = () => {
        handleRequest("get", YOUTUBE_CHANNEL_API_URL(props.channel), {}, {}, (data, status) => {
            if (status === "Done") {
                setData(data);
            } else if (status === "Error") {
                console.error(data);
            }
        }, true)
    }

    return (
        <YoutubeBigPage
            {...props}
            data={data}
            status={status}
            handleReload={handleReload}
        />
    );
};

export default YoutubeBig;